import * as React from 'react'

interface IEntityProvidersProps {
  children: any
  className?: any
}

const EntityProviders = (props: IEntityProvidersProps) => (
  <div className={`col-8 ${props.className}`}>
    <div className='flex flex-row bb-light-grey4 pb1'>
      <div className='col-5 font-light-grey h5 bold'>Providers</div>
      <div className='col-7 font-light-grey h5 bold'>Products</div>
    </div>
    {props.children}
  </div>
)

const EntityProviderItem = ({ children, className }: any) => (
  <div className={`flex flex-row bb-light-grey4 pt2 pb2 ${className}`}>{children}</div>
)

const EntityProviderItemColLeft = ({ children }: any) => (
  <div className='col-5'>
    <div className='flex flex-row items-center'>{children}</div>
  </div>
)

const EntityProviderItemColRight = ({ children }: any) => <div className='col-7 pt1'>{children}</div>

const EntityProviderItemName = ({ children }: any) => <div className='ml1 font-dark-grey'>{children}</div>

const EntityProviderItemProduct = ({ children }: any) => (
  <div className='border-light-grey4 rounded mb2 mr2 pl1 pr1 pt02 pb02 inline-block h6 font-blue-grey'>{children}</div>
)

export {
  EntityProviders,
  EntityProviderItem,
  EntityProviderItemColLeft,
  EntityProviderItemColRight,
  EntityProviderItemName,
  EntityProviderItemProduct
}



// WEBPACK FOOTER //
// ./src/components/ui/entity/EntityProviders.tsx